import React from 'react';
import { motion } from 'framer-motion';
import { drawCircle, fillLines } from './helpers';
import {
  GamePieceContainer,
  GamePieceContainerBG,
  GamePieceCover,
  SVG,
  SVGPath,
  SVGPolyline,
  SVGRect,
} from './styles';

const GamePiece = ({
  color,
  id,
  moveSet,
  atLastPosition,
  inEnteringSpace,
  clickHandler,
  cycleRackHandler,
  cycleSpaceHandler,
  handleMouseEnter,
  handleMouseLeave,
}) => (
  <GamePieceContainer
    as={motion.div}
    layoutId={`piece_${id}`}
    onClick={() => clickHandler(id)}
    onMouseEnter={() => handleMouseEnter(id)}
    onMouseLeave={() => handleMouseLeave(id)}
    whileHover={{ scale: 1.05 }}
    style={{ position: inEnteringSpace ? 'absolute' : 'relative' }}
  >
    <GamePieceContainerBG>
      <GamePieceCover bgColor={color}>
        <SVG viewBox="0 0 242 322" fillColor={color}>
          <defs>
            <pattern
              id="grid"
              width="80"
              height="80"
              patternUnits="userSpaceOnUse"
            >
              <SVGPath d="M 80 0 L 0 0 0 80" />
            </pattern>
          </defs>
          <SVGRect />
          <SVGPolyline points={fillLines(moveSet)} />
          {moveSet.map((pos) => drawCircle(pos, color))}
        </SVG>
        <button
          onClick={cycleRackHandler}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            visibility: atLastPosition ? 'visible' : 'hidden',
          }}
        >
          To Rack
        </button>
        <button
          onClick={cycleSpaceHandler}
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            visibility: atLastPosition ? 'visible' : 'hidden',
          }}
        >
          ESpace
        </button>
      </GamePieceCover>
    </GamePieceContainerBG>
  </GamePieceContainer>
);

export default GamePiece;
